import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-detalhe-pg-layout',
  templateUrl: './detalhe-pg-layout.component.html',
  styleUrls: ['./detalhe-pg-layout.component.scss']
})
export class DetalhePgLayoutComponent {

  type: string = '';

  constructor(
    public activatedRoute: ActivatedRoute,
    private navigation: NavigationService
  ) { }

  ngOnInit(): void {
    this.type = this.activatedRoute.snapshot.data['type'];
  }

}
